import type { SupportedClient } from "@contracts/contract-2-plugin-store";

export const CLIENT_CONFIG: Record<SupportedClient, { label: string; color: string; bg: string; border: string }> = {
  "claude-chat":   { label: "Claude Chat",    color: "var(--color-info-text)", bg: "var(--color-info-bg)", border: "var(--color-info-border)" },
  "claude-cowork": { label: "Claude Cowork",  color: "var(--color-official-text)", bg: "var(--color-success-bg)", border: "var(--color-success-border)" },
  "claude-code":   { label: "Claude Code",    color: "var(--color-badge-plugin-text)", bg: "var(--color-badge-plugin-bg)", border: "var(--color-badge-plugin-border)" },
};

interface ClientBadgeProps {
  client: SupportedClient;
  onClick?: (client: SupportedClient) => void;
}

export default function ClientBadge({ client, onClick }: ClientBadgeProps): JSX.Element {
  const config = CLIENT_CONFIG[client];
  if (!config) {
    console.warn(`[ClientBadge] Unknown client value: "${client}". Entry may predate the client rename. Run the reprocess script to migrate.`);
  }
  const resolved = config ?? { label: client, color: "var(--color-text-secondary)", bg: "var(--color-surface-secondary)", border: "var(--color-border)" };

  const sharedStyle = {
    display: "inline-block",
    fontSize: "0.75rem",
    fontWeight: 600 as const,
    color: resolved.color,
    backgroundColor: resolved.bg,
    padding: "0.2rem 0.5rem",
    borderRadius: "9999px",
    whiteSpace: "nowrap" as const,
  };

  if (onClick) {
    return (
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(client); }}
        style={{ ...sharedStyle, cursor: "pointer", border: "none", fontFamily: "inherit" }}
      >
        {resolved.label}
      </button>
    );
  }

  return (
    <span style={{ ...sharedStyle, cursor: "default" }}>
      {resolved.label}
    </span>
  );
}
